import React from 'react'
import cx from 'classnames'

import Text from 'components/_new/typography/Text/Text'
import RadioButtonContainer from '../RadioButtonContainer/RadioButtonContainer'

import s from './RadioButton.scss'


export type RadioButtonProps = {
  className?: string
  label?: ReactIntlMessage | string
  value: string | number
  dataTestId?: string
}

const RadioButton: React.FunctionComponent<RadioButtonProps> = (props) => {
  const { children, className, label, value, dataTestId } = props

  const rootClassName = cx(s.radioButton, className)

  return (
    <RadioButtonContainer
      className={rootClassName}
      inputClassName={s.input}
      value={value}
      dataTestId={dataTestId}
    >
      <div className={s.radio} />
      {
        Boolean(label) && (
          <Text message={label} html />
        )
      }
      {children}
    </RadioButtonContainer>
  )
}


export default RadioButton
